import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { BTN } from "@/components/common/btn";

// "Complete" button + inline confirm flow. Shared across Draft,
// Submitted, Approved, and Scheduled action groups so all four agree
// on the exact same green-button → confirm banner UX.
export function WOCompleteButton({
  confirmWOComplete, setConfirmWOComplete,
  onConfirm,
}) {
  if (!confirmWOComplete) {
    return (
      <Button size="sm" className={BTN.write} onClick={() => setConfirmWOComplete(true)} data-testid="btn-complete-wo">
        <Check className="w-3.5 h-3.5 mr-1" /> Complete
      </Button>
    );
  }
  return (
    <div className="flex items-center gap-2 animate-in fade-in duration-200">
      <span className="text-xs font-medium text-amber-700 bg-amber-50 px-2 py-1 rounded">
        Confirm 100% complete?
      </span>
      <Button size="sm" className={BTN.write} onClick={() => { setConfirmWOComplete(false); onConfirm(); }} data-testid="btn-confirm-complete-wo">
        Confirm
      </Button>
      <Button size="sm" className={BTN.nav} onClick={() => setConfirmWOComplete(false)} data-testid="btn-cancel-complete-wo">
        Cancel
      </Button>
    </div>
  );
}
